export default "__VITE_ASSET__CwQc6kjT__"